module.exports = __webpack_public_path__ + "img/password.0e69bd09.svg";